import { render } from "./latesPhotos.vue?vue&type=template&id=45e8be18"
import script from "./latesPhotos.vue?vue&type=script&lang=js"
export * from "./latesPhotos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__